import { handleServiceRequest } from '../handle-service-request';

const baseUrl = `/api/CollectionProcessing`;

export const getActionLogs = id => {
    const getObject = {
        url: `${baseUrl}/Logs/${id}`,
    };
    return handleServiceRequest.get(getObject);
};

export const getOptions = () => {
    const getObject = {
        url: `${baseUrl}/ActionOptions`,
    };
    return handleServiceRequest.get(getObject);
};

export const commitAction = (actionId, reportingYear, reportingGroup) => {
    const getObject = {
        url: `${baseUrl}/Run/${actionId}/${reportingYear}/${reportingGroup}`,
    };
    return handleServiceRequest.get(getObject);
};

export const CollectionProcessingService = {
    getActionLogs,
    commitAction,
    getOptions,
};
